
import store from '@/store';
import { defineComponent } from 'vue';
import { GlobalPagination } from '@/interfaces/panel/global-pagination.model';
import IpgTransactionSkelton from '@/components/transactionsComponents/IpgTransactionSkelton.vue';
import CommissionTableComponent from '@/components/appComponents/CommissionTable.vue';
import CustomPaginationComponent from '@/components/appComponents/CustomPagination.vue';

export default defineComponent({
    name: "CommissionsListPage",

    components: { IpgTransactionSkelton, CommissionTableComponent,  CustomPaginationComponent },

    data() {
        return {
            user: ""
        }
    },

    computed: {
        getLoadingPanel(): boolean {
            return store.getters["panel/getLoadingPanel"];
        },

        getCommissions() {
            return store.getters["panel/getCommissions"];
        },

        getGlobalPagination(): GlobalPagination {
            return store.getters["panel/getGlobalPagination"];
        }
    },

    methods: {
        handelPagination() {
            store.dispatch("panel/getCommissionsRequest");
        }
    },

    mounted() {
        store.dispatch("panel/getCommissionsRequest");
    }
})
